import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useActivityContext } from '../../../hooks/use-activity.context';
import { ContinueButton } from '../../continue-button/continue-button';
import { Instruction } from '../../instruction/instruction.component';
import type { ActivityProps } from '../activity-props';

export function NotImplementedActivity({
  completionButtonText,
}: ActivityProps) {
  const {
    isCurrentActivityComplete: isComplete,
    completeCurrentActivity: completeActivity,
    goNext,
  } = useActivityContext();

  useEffect(() => {
    if (!completeActivity) {
      return;
    }
    if (!isComplete) {
      completeActivity();
    }
  }, [completeActivity, isComplete]);

  return (
    <>
      <SafeAreaView edges={['bottom']} style={styles.safeArea}>
        <View style={styles.container}>
          <Instruction text="This activity has not yet been implemented" />
        </View>
      </SafeAreaView>
      {isComplete && (
        <ContinueButton onPress={goNext} action={completionButtonText} />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  container: {
    flex: 1,
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
